import { mutateProjectTypes } from '../../mutations/mutateProjectTypes';
import { organizationAPI } from 'api/phases/endpoints';

export const removeProjectType = async (typeId: number) => {
  await organizationAPI.deleteProjectType(typeId);
  await mutateProjectTypes();
};
